(function () {
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  // reveals
  if (!rm && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in'); io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }
  // promo copy
  var code = document.getElementById('promoCode');
  if (code) code.addEventListener('click', function () {
    var self = this;
    if (navigator.clipboard) navigator.clipboard.writeText('LAUNCH10').then(function () {
      var old = self.textContent; self.textContent = 'Copied! ✓';
      setTimeout(function () { self.textContent = old; }, 1500);
    });
  });
})();
